export enum AuditEntityClass {
  AuditRiskEntry = 'AuditRiskEntry',
  AuditQualityEntry = 'AuditQualityEntry',
}
